import request from '@host-panel/request';
import { dispatch } from 'state/store';
import {
  codeVerificationFailed,
  onSendConfirmationCodeStart,
  onSendConfirmationCodeSuccess
} from '../../../../../auth/authSlice';

interface Context {
  dispatch(action: string, payload: any): void;
}

interface RequestParams {
  spotId: string;
  userEmail: string;
  dispatchEvent: (success: boolean) => void;
  isResend?: boolean;
}

export async function handleConfirmationCode(
  context: Context,
  { spotId, userEmail, dispatchEvent, isResend = false }: RequestParams
): Promise<void> {
  dispatch(onSendConfirmationCodeStart());
  try {
    const res = await requestCode(spotId, userEmail, isResend);

    if (res?.type && !res.success) {
      handleFailure(res, dispatchEvent);
    } else {
      handleSuccess(dispatchEvent);
    }
  } catch (reason) {
    handleFailure(reason, dispatchEvent);
  }
}

function handleSuccess(dispatchEvent: (success: boolean) => void): void {
  dispatch(onSendConfirmationCodeSuccess());
  dispatchEvent(true);
}

function handleFailure(reason: any, dispatchEvent: (success: boolean) => void): void {
  try {
    dispatch(codeVerificationFailed(reason));
    console.error(reason);
  } catch (ex) {
    console.error(ex);
  }
  dispatchEvent(false);
}

function requestCode(spotId: string, email: string, isResend: boolean): Promise<any> {
  const url = isResend
    ? `/spot/${spotId}/mfa/resend_confirmation_code`
    : `/spot/${spotId}/mfa/send_confirmation_code`;

  return request(url, {
    method: 'POST',
    service: 'moderation',
    data: { Email: email }
  });
}
